export const BANNER_TITLE_AMOUNT = '37,000,000+';

export const TOTAL_REWARD_AMOUNT = '1,000,000';
export const TOP_REWARD_AMOUNT = '800,000';
export const GRANT_REWARD_AMOUNT = '800,000';
export const DAILY_REWARD_AMOUNT = '200,000';
export const GRANT_REWARD_BASE = '600,000';
export const GRANT_REWARD_PERSONAL_TOP = '88,000';
export const REWARD_UNIT = 'USDT';
export const TOKEN_NAME = 'MNT';
export const SINGLE_LIMIT = '50,200';
export const DOUBLE_LIMIT = '100,400';

export const TOP_SUPPORTERS_SHARE = {
  FISRT: {
    amount1: '1,000',
    amount2: '264,000',
  },
  SECOND: {
    amount1: '500',
    amount2: '156,000',
  },
  THIRD: {
    amount1: '500',
    amount2: '132,000',
  },
  FORTH: {
    amount1: '200',
    amount2: '48,000',
  },
};

export const WSOT_IDOL = 'WSOT DEX Wave';

export const WSOT_START_DATE = '2024.10.1';
export const WSOT_END_DATE = '2024.10.31';

export const DEFAULT_VAL = '--';
export const TRADE_UNIT = 'U';

export const DEX_PRO_SOL_URL = '/web3/dex/sol';
export const DEX_PRO_SOL_APP =
  'by://web3/tab/index?tag=swap&swapBizType=dex&dexProTokenSymbol=SOL&dexProTokenAddress=eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee&dexProChainId=999999997&pageSource=aidol2025';

export const SHARE_WSOT_REWARD = '1,000,000';

export const DAILY_WSOT_REWARD = '200,000';

export const WSOT_LOTTERY_COUNT_MAP = {
  FIRST_WEEK: 3,
  SECOND_WEEK: 3,
  THIRD_WEEK: 3,
  LAST_WEEK: 1,
};
export const WSOT_LOTTERY_DATE_MAP = {
  FIRST_WEEK: '2024.10.1 10:00 UTC - 2024.10.8 10:00 UTC',
  SECOND_WEEK: '2024.10.8 10:00 UTC - 2024.10.15 10:00 UTC',
  THIRD_WEEK: '2024.10.15 10:00 UTC - 2024.10.22 10:00 UTC',
  LAST_WEEK: '2024.10.22 10:00 UTC - 2024.10.31 10:00 UTC',
};

export const TRADE_LOTTERY_INFO_LIST = [
  {
    week: 1,
    time: WSOT_LOTTERY_DATE_MAP.FIRST_WEEK,
    lotteryCount: WSOT_LOTTERY_COUNT_MAP.FIRST_WEEK,
  },
  {
    week: 2,
    time: WSOT_LOTTERY_DATE_MAP.SECOND_WEEK,
    lotteryCount: WSOT_LOTTERY_COUNT_MAP.SECOND_WEEK,
  },
  {
    week: 3,
    time: WSOT_LOTTERY_DATE_MAP.THIRD_WEEK,
    lotteryCount: WSOT_LOTTERY_COUNT_MAP.THIRD_WEEK,
  },
  {
    week: 4,
    time: WSOT_LOTTERY_DATE_MAP.LAST_WEEK,
    lotteryCount: WSOT_LOTTERY_COUNT_MAP.LAST_WEEK,
  },
];

export const DOLLAR = '$';

export const WSOT_HOME_PAGE = '/web3/aidol2025';
